import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal } from './Modal'
import { HeaderModal } from './Header'
import { Body } from './Body'
import { FooterModal } from './Footer'
import closeIcon from 'assets/images/close-icon.svg';
import modalBgShade from "../../../assets/images/bg-modal-shade.svg";
import allImgPaths from 'assets/images';
import CustomCheckBox from 'components/CustomCheckBox';
import { getFileContent, listData } from 'services/event';
import { cloneDeep } from 'lodash';
import { ExistingSettingMemberLoader } from 'components/loaders';
import CustomDropdown from '../dropdown/Dropdown';
import CustomSelect from '../CustomSelect';
import { format } from 'date-fns';
import Toast from '../Toast';

const pageOptions = [
    10, 50, 100, 500, 1000
]

const ListModal = ({ data: templateData, ids, setShowListModal, type, category }: any) => {
    const { id: eventId, draftEventId } = useParams();
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [allSelected, setAllSelected] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [perPage, setPerPage] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [finalPage, setFinalPage] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalEmailSent, setTotalEmailSent] = useState(0)
    const [showDismissBox, setShowDismissBox] = useState(false);
    const [isFocused, setIsFocused] = useState<boolean>(false);
    const [initListPayload, setInitListPayload] = useState<any>({
        event_id: eventId,
        perPage: perPage,
        page: currentPage,
        category: category
    })
    const [originalData, setOriginalData] = useState<any>([])

    const [currentSort, setCurrentSort] = useState(0)
    const [showFilesData, setShowFilesData] = useState(false)

    const [sortOrder, setSortOrder] = useState('asc');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [allKeys, setAllKeys] = useState<any>([]);
    const [sortField, setSortField] = useState<any>(null);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const handleInput = (e: any) => {
        if (!e.target.value) {
            setSearchText('');
            handleSearch(e, true)
        }
    }

    // On First Load
    useEffect(() => {
        if (templateData?.filename) {
            setFilePayload([templateData?.filename])
            setShowFilesData(true)
        }
    }, [])

    // Setup payload for fetching attendee list of the selected file
    const setFilePayload = (files: any[]) => {
        const updatedListPayload = cloneDeep(initListPayload);
        updatedListPayload['category'] = category;
        updatedListPayload['file_name'] = files;

        setInitListPayload(updatedListPayload)
        fetchList(updatedListPayload)
    }

    // Fetch attendee list data for selected files
    const fetchList = async (listPayload: any) => {
        setLoading(true)

        try {
            const { data } = await listData(listPayload)
            const updatedData = setListData(data?.data)
            setTotalData(data?.length)
            setCurrentPage(listPayload.page)
            setFinalPage(Math.ceil(data?.length / listPayload.perPage))
            console.log({ attendeeData: updatedData })
            setData(updatedData)
            setOriginalData(cloneDeep(updatedData))
            setLoading(false)
            setShowFilesData(true)
        } catch (error) {
            setLoading(false)
            setListData([])
        }
    }

    const setListData = (data: any[]) => {
        if (data?.length) {
            data.map((dt: any) => {
                dt['selected'] = false;
                dt['isEditMode'] = false
            });

            const uniqueKeys = new Set();
            data.forEach(item => {
                if (item.all_data) {
                    Object.keys(item.all_data).forEach(key => uniqueKeys.add(key));
                }
            });
            const allKeysData = [...Array.from(uniqueKeys)]
            let orderedKeys = [
                "first name",
                "last name",
                "email",
                ...allKeysData.filter((item: any) => !["first name", "last name", "email"].includes(item))
            ];
            setAllKeys(orderedKeys)

            return data
        }
        return []
    }

    // Handle search of attendee list data
    const handleSearch = async (e: any, fromClose = false) => {
        e.preventDefault()
        const text = fromClose ? '' : (searchText ? searchText.trim() : '');
        const clonedListPayload: any = cloneDeep(initListPayload);
        clonedListPayload['query'] = text;
        setInitListPayload(clonedListPayload)
        await fetchList(clonedListPayload)
    }

    // Handle page change of attendee list data
    const handlePageChange = async (page: number) => {
        if (page > 0) {
            const clonedListPayload: any = cloneDeep(initListPayload);
            clonedListPayload['page'] = page;

            setInitListPayload(clonedListPayload)
            await fetchList(clonedListPayload)
        }
    }

    // Handle sorting of attendee list data
    const [arrowUp, setArrowUp] = useState(false);
    const handleSort = (type: string) => {
        const sortedData = [...data].sort((a, b) => {
            if (type == 'sentTime') {
                const dateA: any = new Date(a.sentTime);
                const dateB: any = new Date(b.sentTime);
                if (sortOrder === 'asc') {
                    return dateA - dateB;
                } else {
                    return dateB - dateA;
                }
            } else {
                if (sortOrder === 'asc') {
                    return a['all_data'][type].localeCompare(b['all_data'][type]);
                } else {
                    return b['all_data'][type].localeCompare(a['all_data'][type]);
                }
            }
        });
        setData(sortedData);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');

        setArrowUp(!arrowUp);
        setSortField(type);
    };

    // Handle per page change of attendee list data
    const handlePerPageChange = async (e: any) => {
        const value = +e.target.value;
        if (value != perPage) {
            const clonedListPayload: any = cloneDeep(initListPayload);
            clonedListPayload['perPage'] = value;
            clonedListPayload['page'] = 1;
            setInitListPayload(clonedListPayload)
            await fetchList(clonedListPayload);

            setPerPage(value)
        }
    }

    return (
        <div>
            <Modal className={"modal-wrapper max-w-[1360px]"} isShow={setShowListModal}>
                <HeaderModal title={''} isShowHeader={true} className="modal-header">
                    <div className="flex items-center justify-between py-4 px-4 border-b border-[#EAECF0]">
                        <div className="flex items-center gap-x-2">
                            <img src={allImgPaths.suggestionView2} alt="" />
                            <h2 className="text-xl text-[#101828] font-interSemiBold leading-none">
                                View File - {templateData?.original_file_name || templateData?.filename || 'Attendee List'}
                            </h2>
                        </div>
                        {/* Close Icon */}
                        <img
                            className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 mr-4"
                            id="modal-toggle"
                            src={closeIcon}
                            onClick={() => { setShowListModal(false) }}
                            alt="close icon"
                        />
                    </div>
                </HeaderModal>
                <Body title="" isShowBody={true} className="modal-body px-6 flex gap-x-4 max-h-[calc(100vh_-_326px)] pt-7">
                    <div className='border border-[#EAECF0] rounded-xl mb-6'>

                        <div className='px-6 pt-5'>

                            <div className="flex items-center gap-x-2 mb-5">
                                <span className='text-base font-interSemiBold text-[#101828]'>Attendees List</span>

                                <span className='bg-[#e8e6fe] border border-[#958de3] rounded px-2 py-0.5 inline-block text-sm text-[#1E0AF5] font-interSemiBold'>
                                    {totalData}
                                </span>
                            </div>


                            <>
                                <div className='flex items-center mb-6 justify-between w-full'>
                                    <form onSubmit={(e: any) => handleSearch(e, false)} className="flex items-center">
                                        <div className={`border hover:border-[#1E0AF5] rounded-lg w-80 py-2.5 px-3.5 flex items-center gap-x-2 ${isFocused ? "border-[#1e0af5]" : "border-[#D0D5DD]"}`}>
                                            <img src={allImgPaths.searchIcon} alt="search" />
                                            <input
                                                className="w-full"
                                                placeholder="Search by Name or Email"
                                                type="text"
                                                onChange={(e) => setSearchText(e.target.value)}
                                                value={searchText}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                onInput={handleInput}
                                            />

                                            {
                                                searchText &&
                                                <img
                                                    className='cursor-pointer hover:bg-[#FEE4E2] rounded w-5 p-1'
                                                    src={allImgPaths.closeIconRed}
                                                    alt=""
                                                    onClick={(e) => {
                                                        setSearchText('');
                                                        handleSearch(e, true)
                                                    }}
                                                />
                                            }
                                        </div>
                                        <button
                                            type='submit'
                                            className={`submit-btn-blue !px-4 ml-5 !py-2.5 hover:bg-[#120693] ${searchText ? '' : 'button-disabled'}`}
                                            disabled={searchText ? false : true}
                                        >
                                            Search
                                        </button>
                                    </form>
                                </div>
                                {loading && <ExistingSettingMemberLoader />}
                                {
                                    !loading && data && data?.length > 0 &&
                                    <>
                                        <div className="overflow-x-auto w-[calc(100vw_-660px)]">
                                            <div className="custom-table-grid-attendees-list-edit whitespace-nowrap">
                                                {
                                                    allKeys?.length > 0 && allKeys.map((key: any, kIndex: number) => (
                                                        <React.Fragment key={kIndex}>
                                                            <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r first-of-type:rounded-tl-lg last-of-type:rounded-tr-lg'>
                                                                <span
                                                                    className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center"
                                                                    onClick={() => handleSort(key)}
                                                                >
                                                                    {key}
                                                                    <img
                                                                        className={`w-4 cursor-pointer transform ${(sortField === key && sortOrder == 'asc') ? "rotate-0" : "rotate-180"}`}
                                                                        src={allImgPaths.arrowUp3} alt=""
                                                                    />
                                                                </span>
                                                            </div>
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </div>


                                            <div className="custom-table-grid-attendees-list-edit max-h-[calc(100vh_-_680px)]">
                                                {
                                                    allKeys?.length > 0 && allKeys.map((key: any, kIndex: number) => (
                                                        <div className="min-w-[220px] flex flex-col border border-[#EAECF0] border-r-0 last:border-r" key={kIndex}>
                                                            {
                                                                data?.length > 0 && data.map((dt: any, index: number) => (
                                                                    <div key={index} className='flex items-center gap-x-3 py-3 px-2 border-b last:border-b-0 border-[#EAECF0] checkbox-alignment'>
                                                                        <div className="flex gap-x-3 items-center">
                                                                            <p className='text-[#101828] text-sm font-interMedium'>
                                                                                {dt.all_data[key] || '-'}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }

                                                        </div>
                                                    ))
                                                }
                                            </div>

                                        </div>

                                        {/* Pagination Box */}
                                        <div className="flex w-full items-center mt-5 mb-5">
                                            <div>
                                                <select
                                                    value={perPage}
                                                    onChange={handlePerPageChange}
                                                    className='mr-5 border border-[#ccc] px-3 py-1.5 rounded-md' id="numberDropdown" name="numberDropdown">
                                                    {
                                                        pageOptions.map((po: any, index: number) => (
                                                            <option value={po} key={index}>
                                                                {po}
                                                            </option>
                                                        ))
                                                    }
                                                </select>

                                            </div>

                                            <div className="flex items-center gap-x-1">
                                                <span className='text-sm text-[#344054] font-interMedium'>Page</span>
                                                <span className='text-sm text-[#344054] font-interMedium'>{currentPage}</span>
                                                <span className='text-sm text-[#344054] font-interMedium'>of</span>
                                                <span className='text-sm text-[#344054] font-interMedium'>
                                                    {finalPage}
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1.5">
                                                {
                                                    (currentPage != 1 || currentPage == finalPage) && totalData > perPage &&
                                                    <img
                                                        className='cursor-pointer'
                                                        src={allImgPaths.pagiLeftBtn}
                                                        alt=""
                                                        onClick={() => handlePageChange(currentPage - 1)} />
                                                }
                                                {
                                                    currentPage != finalPage &&
                                                    <img
                                                        className='cursor-pointer'
                                                        src={allImgPaths.pagiRightBtn}
                                                        alt=""
                                                        onClick={() => handlePageChange(currentPage + 1)} />
                                                }
                                            </div>
                                        </div>
                                    </>
                                }
                                {
                                    !loading && !data?.length &&
                                    <div className='ml-3'>
                                        <h3>No Attendees Available</h3>
                                    </div>
                                }
                            </>

                        </div>
                    </div >
                </Body>
                <FooterModal title="" isShowFooter={true} className="modal-footer pb-6 px-6 pt-4">
                    <div className="flex justify-end gap-x-3">
                        <button
                            className='cancle-btn-blue !px-[15px] !text-sm hover:bg-[#F2F4F7]'
                            onClick={() => { setShowListModal(false) }}>
                            Close
                        </button>
                    </div>
                </FooterModal>
            </Modal>
        </div>
    )
}

export default ListModal